import request from '@/utils/request'

// 顶部和底部菜单

export function getMenuShowApi(data = {}) {
  return request({
    method: 'post',
    url: 'v1/web/menu/show',
    data
    // responseType: 'blob'
  })
}

// 公司详细信息
export function getcompanyDetailApi(data = {}) {
    return request({
        method: 'POST',
        url: 'v1/web/company/companyDetail',
        data
    })
}

// 通用模块展示
export function queryByModuleCodeApi(data = {}) {
    return request({
        method: 'POST',
        url: 'v1/web/module/queryByModuleCode',
        data
    })
}

// minio文件上传接口
export function uploadMinioApi(data = {}) {
    return request({
        method: 'post',
        url: 'v1/minio/upload',
        data
    })
}

// 1.2.2.6.minio文件删除接口

export function removeMinioApi(data = {}) {
    return request({
        method: 'post',
        url: 'v1/minio/remove',
        data
    })
}

export function createApi(data = {}) {
    return request({
        method: 'post',
        url: 'v1/web/user/submit/create',
        data
    })
}